import { QueryDispatcher } from "../../shared/domain/QueryDispatcher";

export class WorkflowTemplatesQuery {
  constructor(
    private readonly dispatcher: QueryDispatcher,
    private readonly frontend,
  ) { }

  async run(): Promise<any> {
    try {
      let res = await this.dispatcher.dispatch('workflow.templates.query', {})
      if (res) {
        this.frontend.workflowOptions.push(...Object.values(res));      
      }
    } catch (error) {
      console.error(error)
    }
    
    
  }
}